import 'components/CustomSelect/customSelect.style.css';
import { InfoBanner } from './style';
import InfoIcon from '@mui/icons-material/Info';
import { PERMISSIONS } from 'utils/constants';
import { Typography } from '@mui/material';

const InnerBanner = (props) => {
  const { item } = props;

  return (
    <>
      {item?.title === PERMISSIONS.CAN_ONLY_VIEW_OWN_TASKS && (
        <InfoBanner direction="row" alignItems="center" gap="7px">
          <InfoIcon className="icon" />
          <Typography className="content">
            Please enable <b>Access Task</b> permission above to be able to view
            tasks.
          </Typography>
        </InfoBanner>
      )}
      {item?.title === PERMISSIONS.CAN_MANAGE_USERS_PASSWORD && (
        <InfoBanner direction="row" alignItems="center" gap="7px">
          <InfoIcon className="icon" />
          <Typography className="content">
            Please enable <b>Add/Remove Users</b> permission above to be able to
            Set Or Update Users Password.
          </Typography>
        </InfoBanner>
      )}
      {item?.title === PERMISSIONS.CAN_MANAGE_TASKS && (
        <InfoBanner direction="row" alignItems="center" gap="7px">
          <InfoIcon className="icon" />
          <Typography className="content">
            Please enable <b>View Task</b> permission above to be able to manage
            tasks.
          </Typography>
        </InfoBanner>
      )}

      {item?.title === PERMISSIONS.CAN_MANAGE_LOG_SUBMISSION && (
        <InfoBanner direction="row" alignItems="center" gap="7px">
          <InfoIcon className="icon" />
          <Typography className="content">
            Templates <b>Visibility</b> and <b>Edit permissions</b> can be
            configured individually for each custom template.
          </Typography>
        </InfoBanner>
      )}

      {item?.title === PERMISSIONS.CAN_VIEW_ALL_SUBMISSIONS && (
        <InfoBanner direction="row" alignItems="center" gap="7px">
          <InfoIcon className="icon" />
          <Typography className="content">
            Can / Atleast select one <b>View Submissions Permission</b> at a
            time.
          </Typography>
        </InfoBanner>
      )}
      {item?.title === PERMISSIONS.CAN_VIEW_OWN_TASK_REQUESTS_ONLY && (
        <InfoBanner direction="row" alignItems="center" gap="7px">
          <InfoIcon className="icon" />
          <Typography className="content">
            Please enable <b>'Access Work Order Requests'</b> permission above
            to be able to view work order requests.
          </Typography>
        </InfoBanner>
      )}
      {item?.title === PERMISSIONS.CAN_REQUEST_TASK && (
        <InfoBanner direction="row" alignItems="center" gap="7px">
          <InfoIcon className="icon" />
          <Typography className="content">
            Please enable <b>'View Work Order Requests'</b> permission above to
            be able to manage work order requests.
          </Typography>
        </InfoBanner>
      )}
      {item?.title === PERMISSIONS.CAN_CREATE_AND_MANAGE_OWN_ANNOUNCEMENTS && (
        <InfoBanner direction="row" alignItems="center" gap="7px">
          <InfoIcon className="icon" />
          <Typography className="content">
            Please enable <b>Access Announcements</b> permission above to be
            able to view announcements.
          </Typography>
        </InfoBanner>
      )}

      {item?.title === PERMISSIONS.CAN_ONLY_VIEW_OWN_WORK_ORDERS && (
        <InfoBanner direction="row" alignItems="center" gap="7px">
          <InfoIcon className="icon" />
          <Typography className="content">
            Please enable <b>Access Work Orders</b> permission above to be able
            to view Work Orders.
          </Typography>
        </InfoBanner>
      )}

      {item?.title === PERMISSIONS.CAN_MANAGE_WORK_ORDERS && (
        <InfoBanner direction="row" alignItems="center" gap="7px">
          <InfoIcon className="icon" />
          <Typography className="content">
            Please enable <b>View Work Orders</b> permission above to be able to
            manage work orders.
          </Typography>
        </InfoBanner>
      )}
    </>
  );
};

export default InnerBanner;
